import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_get_tasks_by_chainHeadService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { chainHead: number }): 
  Promise<{ result: { Id?: number, SerialNumberId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.chainHead)) {
      missingRequiredInParams.push('\'chainHead\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { chainHead: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, SerialNumberId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.chainHead)) {
      missingRequiredInParams.push('\'chainHead\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { chainHead: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, SerialNumberId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.chainHead)) {
      missingRequiredInParams.push('\'chainHead\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      chainHead: number    }) {
        if(isNil(inParams.chainHead)) {
          return true; 
        }
      return false;
    }
}
